import React from "react";
import ModalWrap from "./ModalWrap";
import { Backdrop, Fade, Typography } from "@mui/material";
import "./removesuccess.scss";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { USER_LIST } from "../../routes/routerPath";
import { getParams, searchParams } from "../../utlis/helpers";
import successTick from "../../assets/images/successTick.svg";
import { pageLocale } from "../../utlis/locale";

const RemoveSuccess = ({ removePopUp, setRemovePopup, userInfo }) => {
  const navigate = useNavigate();
  const { removed, ok } = pageLocale("popup");
  const okHandler = () => {
    setRemovePopup(false);
    navigate(USER_LIST + `${searchParams}`);
  };
  const { locale } = getParams();
  const enName = userInfo?.first_name + " " + userInfo?.last_name;
  const jaName = userInfo?.last_name + " " + userInfo?.first_name;
  return (
    <ModalWrap
      open={removePopUp}
      slots={{ backdrop: Backdrop }}
      className="remove-success-modal-wrapper"
      onClose={okHandler}
    >
      <Fade in={open}>
        <Box className="remove-modal-box">
          <img src={successTick} alt="success" className="success-img" />
          <Typography className="success-msg">
            {locale === "ja" ? jaName : enName} {removed}
          </Typography>
          <hr className="success-divider" />
          <button className="ok-btn" onClick={okHandler}>
            {ok}
          </button>
        </Box>
      </Fade>
    </ModalWrap>
  );
};

export default RemoveSuccess;
